module.exports = __webpack_public_path__ + "static/computer-baby-8983d11d64cfeb0834d07cfa222303f4.jpg";